import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { IconPin } from 'components/assets/icons';

export function BaseButton({ label = '', color, text, icon, disabled = false, width, height = '28px', padding = '4px 10px', onClick }) {
  let style = { borderRadius: '4px', width, color, height, padding };
  if (text) {
    style = { ...style, background: 'transparent' };
  }

  return (
    <Button
      style={{ ...style }}
      type={text ? 'text' : 'default'}
      icon={icon}
      disabled={disabled}
      onClick={() => {
        if (onClick) onClick();
      }}
    >
      {label}
    </Button>
  );
}

export function OutlinedButton({ label = '', disabled = false, color, borderColor, borderRadius = '4px', backgroundColor, width, height = '28px', onClick }) {
  return (
    <Button
      style={{
        borderRadius,
        color: color || 'var(--color-qmir-sky)',
        borderColor: borderColor || color || 'var(--color-qmir-sky)',
        backgroundColor: backgroundColor || '',
        width,
        height,
        padding: '4px 12px'
      }}
      type="text"
      disabled={disabled}
      onClick={() => {
        if (onClick) onClick();
      }}
    >
      {label}
    </Button>
  );
}
export function FillButton({ loading=false, label = '', color = '#ffffff', borderRadius = '4px', disabled = false, backgroundColor, width, height = '28px', onClick }) {
  const backcolor = disabled? 'var(--color-gray01)' : (backgroundColor || 'var(--color-qmir-sky)');

  return (
    <Button
      style={{
        borderRadius,
        color: color,
        backgroundColor: backcolor,
        width,
        height,
        padding: '4px 12px'
      }}
      type="text"
      loading={loading}
      disabled={disabled}
      onClick={() => {
        if (onClick) onClick();
      }}
    >
      {label}
    </Button>
  );
}

export function ActiveButton({ label = '', active=false,  color = '#ffffff', borderRadius = '4px', disabled = false, width, height = '28px', onClick }) {

  return (
    <Button
      className={`active_${active}`}
      style={{
        borderRadius,
        width,
        height,
        padding: '4px 12px'
      }}
      type="text"
      disabled={disabled}
      onClick={() => {
        if (onClick) onClick();
      }}
    >
      {label}
    </Button>
  );
}


export function IconButton({ color, icon, label = false, disabled = false, onClick }) {
  return (
    // <Button
    //   style={{ color, ...style }}
    //   type={'text'}
    //   icon={icon}
    //   disabled={disabled}
    //   onClick={() => {
    //     if (onClick) onClick();
    //   }}
    // />
    <BaseButton
      color={color}
      padding={'4px 0px'}
      label={label}
      text
      disabled={disabled}
      icon={icon}
      onClick={() => {
        if (onClick) onClick();
      }}
    />
  );
}

export function UploadButton({ text = '업로드', color = '#282B3E99', border = '1px solid', disabled = false, onClick }) {
  let style = { borderRadius: '99px', border: border, borderColor: color, color, backgroundColor: 'transparent' };
  return (
    <Button
      size={'small'}
      style={{ color, ...style }}
      icon={<UploadOutlined />}
      disabled={disabled}
      onClick={() => {
        if (onClick) onClick();
      }}
    >
      {text}
    </Button>
  );
}

export function DownloadButton({ text = '다운로드', borderRadius = '99px', color = '#282B3E99', border = '1px solid', disabled = false, onClick }) {
  let style = { borderRadius, border: border, borderColor: color, color, backgroundColor: 'transparent' };
  return (
    <Button
      size={'small'}
      style={{ color, ...style }}
      icon={<DownloadOutlined />}
      disabled={disabled}
      onClick={() => {
        if (onClick) onClick();
      }}
    >
      {text}
    </Button>
  );
}

export function DownloadFileButton({ text = '양식 다운로드', href, download, borderRadius = '100px', color = 'var(--color-green01)', border = '1px solid', disabled = false, }) {
  let style = { borderRadius, border: border, borderColor: color, color, backgroundColor: 'transparent' };
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = href;
    link.download = download;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  return (
    <Button
      size={'small'}
      style={{ color, ...style }}
      icon={<DownloadOutlined />}
      disabled={disabled}
      onClick={handleDownload}
    >
      {text}
    </Button>
  );
}


export function PinButton({ onClick }) {
  return <BaseButton padding="4px 0px" label="상단고정" text icon={<IconPin />} onClick={onClick} />;
}

export function PinOffButton({ onClick }) {
  return <BaseButton padding="4px 0px" label="상단고정 해제" text icon={<IconPin />} onClick={onClick} />;
}

export function ConfirmButton({ loading=false, label = '확인', onClick }) {
  return <FillButton loading={loading} label={label} backgroundColor={'var(--color-gray03)'} onClick={onClick} />;
}

export function ListButton({ onClick }) {
  return <OutlinedButton label="목록" color={'var(--color-gray03)'} onClick={onClick} />;
}

export function DetailButton({ label = '상세', onClick }) {
  return <OutlinedButton label={label} color={'var(--color-qmir-sky)'} onClick={onClick} />;
}

export function EditButton({ loading=false, label = '수정', onClick }) {
  return <FillButton loading={loading} label={label} backgroundColor={'var(--color-qmir-sky)'} onClick={onClick} />;
}

export function DeleteButton({ onClick }) {
  return <OutlinedButton label="삭제" color={'var(--color-qmir-orange'} onClick={onClick} />;
}
